<template>
  <v-dialog
    scrollable
    v-model="show"
    persistent
    overlay-color=primaryblue
    :overlay-opacity="coverBackground ? 0.9 : 0"
    max-width="600"
  >
    <v-card
      class="intro-dark"
      align="center">
      <v-card-title class="py-2 align-center justify-center">
        <mrx-translation :token="tokens.title"></mrx-translation>
      </v-card-title>
      <v-card-text class="py-4 align-center justify-center modal-text white--text">
        <mrx-translation :token="tokens.instructions"></mrx-translation>
        <div class="pt-4" v-if="id">{{ id }}</div>
        <div v-for="detail in details" :key="detail.label" class="modal-detail">
          <strong>{{ detail.label }}:</strong> {{ detail.value }}
        </div>
      </v-card-text>
      <v-card-actions class="mb-3 px-0 pt-0">
        <v-row v-if="!singleButton" no-gutters class="flex xs6 ps-4 pe-2">
          <v-btn
            id="modal-cancel"
            class="cancel-btn"
            block
            outlined
            depressed
            @click="$emit('cancel')"
          >
            <mrx-translation :token="tokens.cancel"></mrx-translation>
          </v-btn>
        </v-row>
        <v-row no-gutters :class="singleButton ? 'flex xs12 ps-4 pe-4' : 'flex xs6 ps-2 pe-4'">
          <v-btn
            id="modal-agree"
            class="consent modal-btn"
            block
            depressed
            :data-analytics-skip="agreeTracked ? '' : null"
            @click="$emit('agree')"
          >
            <mrx-translation :token="tokens.agree"></mrx-translation>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ui from "@/mixins/ui"

const tokenMap = {
  default: {
    title: 'app.dialog.attention_title',
    instructions: 'app.dialog.attention_title',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.continue',
  },
  delete: {
    title: 'app.dialog.button.delete',
    instructions: 'app.dialog.delete_encounter',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.delete',
  },
  pause: {
    title: 'app.dialog.button.pause',
    instructions: 'app.dialog.pause_encounter',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.pause',
  },
  resume: {
    title: 'app.dialog.button.resume',
    instructions: 'app.dialog.resume_encounter',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.resume',
  },
  resumeUnavailable: {
    title: 'app.dialog.attention_title',
    instructions: 'app.dialog.resume_unavailable',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.ok',
  },
  skip: {
    title: 'app.dialog.attention_title',
    instructions: 'app.dialog.input_followup',
    cancel: 'app.dialog.button.cancel',
    agree: 'app.dialog.button.continue',
  },
}

export default {
  name: "Modal",
  mixins: [ui],
  props: {
    agreeTracked: { type: Boolean, default: false },
    coverBackground: { type: Boolean, default: false },
    details: { type: Array, default: () => [] },
    id: { type: String, default: null },
    show: { type: Boolean, default: false },
    singleButton: { type: Boolean, default: false },
    tokenType: {
      type: String,
      required: true,
      validator: function (value) {
        return tokenMap.hasOwnProperty(value)
      }
    },
  },
  computed: {
    tokens() {
      return tokenMap[this.tokenType] || tokenMap.default
    },
  },
};
</script>

<style scoped>
  .v-card__title {
    background-color: var(--danger);
    text-align: center;
  }
</style>
